if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              console.log("response", response);

                // Store the timer element before cart update
                let cartTimerElement = document.getElementById("cart-timer");
                let timerElement = document.getElementById("timer");
                
                // Check if timer elements exist
                if (!cartTimerElement || !timerElement) {
                    console.log("Timer elements not found before cart update");
                }
                
                // Get parent container of the cart (modify selector if needed)
                let cartContainer = document.querySelector(".cart-container");
                
                // Save the existing timer HTML structure
                let timerHTML = cartTimerElement ? cartTimerElement.outerHTML : null;
                
                // Update the cart
                this.cart.renderContents(response);
                
                // Wait for cart update to complete, then re-add the timer
                setTimeout(() => {
                    console.log("Re-attaching timer after cart update...");
                    if (cartContainer && timerHTML) {
                        let existingTimer = document.getElementById("cart-timer");
                        if (existingTimer) {
                            existingTimer.remove();
                        }
                        cartContainer.insertAdjacentHTML("beforeend", timerHTML);
                        console.log("Timer re-added to cart");
                        let newCartTimerElement = document.getElementById("cart-timer");
                        let newTimerElement = document.getElementById("timer");
                
                        if (!newCartTimerElement || !newTimerElement) {
                            console.log("Re-added timer elements not found");
                            return;
                        }
                
                        newCartTimerElement.style.display = "block";
                
                        let defaultTime = parseInt(newCartTimerElement.getAttribute("data-expiry-time")) * 60 || 600;
                        let time = localStorage.getItem("cartTimer") ? parseInt(localStorage.getItem("cartTimer")) : defaultTime;
                
                        function updateTimer() {
                            if (time <= 0) {
                                localStorage.removeItem("cartTimer");
                                newCartTimerElement.style.display = "none";
                                return;
                            }
                            let minutes = Math.floor(time / 60);
                            let seconds = time % 60;
                            seconds = seconds < 10 ? "0" + seconds : seconds;
                            newTimerElement.textContent = `${minutes}:${seconds}`;
                            time--;
                            localStorage.setItem("cartTimer", time);
                            setTimeout(updateTimer, 1000);
                            console.log("Timer running...");
                        }
                
                        updateTimer();
                    }
                }, 500);

            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            
            // started here (Shipping protection)
            var pro_input = document.querySelector("#protectionCheckbox");
              var cart_tr = document.querySelector("cart-drawer");
              var selected_id = 48858005733723;
              fetch("/cart.js")
                .then((response) => response.json())
                .then((cart) => {
                  let isProductInCart = cart.items.some((item) => item.id === selected_id);
                  console.log("cart.items", cart.items);
              
                  if (!isProductInCart) {
                    $.ajax({
                      type: "POST",
                      url: "/cart/add.js",
                      data: {
                        quantity: 1,
                        id: selected_id,
                        sections: "cart-drawer,cart-icon-bubble",
                        sections_url: window.location.pathname,
                      },
                      dataType: "json",
                      success: function (response) {
                        // Fetch updated cart data after adding product
                        fetch("/cart.js")
                          .then((response) => response.json())
                          .then((updatedCart) => {
                            const subtotal = updatedCart.total_price / 100;
                            cart_tr.renderContents(response);
                            console.log("cart-updated");
                            updateProgressBar(subtotal);
                            updateShippingMessage(subtotal);

                            // Start cart timer if applicable
                        let cartTimerElement = document.getElementById("cart-timer");
                        let timerElement = document.getElementById("timer");
                        if (!cartTimerElement || !timerElement) return;
              
                        let defaultTime =
                          parseInt(cartTimerElement.getAttribute("data-expiry-time")) * 60 || 600;
                        let time = localStorage.getItem("cartTimer")
                          ? parseInt(localStorage.getItem("cartTimer"))
                          : defaultTime;
              
                        function updateTimer() {
                          if (time <= 0) {
                            localStorage.removeItem("cartTimer");
                            cartTimerElement.style.display = "none";
                            return;
                          }
                          let minutes = Math.floor(time / 60);
                          let seconds = time % 60;
                          seconds = seconds < 10 ? "0" + seconds : seconds;
                          timerElement.textContent = `${minutes}:${seconds}`;
                          time--;
                          localStorage.setItem("cartTimer", time);
                          setTimeout(updateTimer, 1000);
                        }
                        updateTimer();
                            
                          });
                      },
                    });
                  } else {
                    console.log("Product is already in the cart. No action taken.");
                  }
                })
                .catch((error) => console.error("Error fetching cart:", error));
            // ended here

             // progress on add to cart click

            const giftids = document.querySelector(".id_here");
            const mediumGiftVariantId = parseInt(giftids?.getAttribute('data_id'), 10) || null;
            const targetGiftVariantId = parseInt(giftids?.getAttribute('data_gift'), 10) || null;
            const main_progress = document.querySelector('.shipping-bar-container');
            
            if (main_progress) {
                function updateProgressBar(subtotal) {
                    let freeShip = parseFloat(document.querySelector(".target-free-ship")?.textContent) || 0;
                    let mediumGift = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
                    let premiumTarget = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;
                    let highestTarget = Math.max(freeShip, mediumGift, premiumTarget);
            
                    let progressBar = document.getElementById("progress-bar");
                    if (progressBar) {
                        let progressPercentage = Math.min((subtotal / highestTarget) * 100, 100);
                        requestAnimationFrame(() => {
                            progressBar.style.transition = "width 1.6s ease-out";
                            progressBar.style.width = progressPercentage + "%";
                        });
                    }
            
                    updateStep(".step1", ".new_hide1", freeShip, subtotal);
                    updateStep(".step2", ".new_hide2", mediumGift, subtotal);
                    updateStep(".step3", ".new_hide3", premiumTarget, subtotal);
                }
            
                function updateStep(stepSelector, hideSelector, target, subtotal) {
                    setTimeout(() => {
                        let step = document.querySelector(stepSelector);
                        let hideElement = document.querySelector(hideSelector);
                        if (step && hideElement) {
                            if (subtotal >= target) {
                                step.classList.add("hide-main");
                                hideElement.classList.add("active");
                                hideElement.style.display = "block";
                            } else {
                                step.classList.remove("hide-main");
                                hideElement.classList.remove("active");
                                hideElement.style.display = "none";
                            }
                        }
                    }, 1000);
                }
            
                function updateShippingMessage(subtotal) {
                    let freeShipTarget = parseFloat(document.querySelector(".target-free-ship")?.textContent) || 0;
                    let mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
                    let targetAmount = parseFloat(document.querySelector(".target_amount")?.textContent) || 0;
            
                    let shippingMessage = document.getElementById("shipping-message");
            
                    if (shippingMessage) {
                        let spans = shippingMessage.querySelectorAll("span:not(.amount-placeholder)");
                        let amounts = shippingMessage.querySelectorAll(".amount-placeholder");
            
                        spans.forEach(span => span.style.display = "none");
            
                      // Convert values to numbers or null if empty
                    let freeShipTargetNum = freeShipTarget ? Number(freeShipTarget) : null;
                    let mediumGiftTargetNum = mediumGiftTarget ? Number(mediumGiftTarget) : null;
                    let targetAmountNum = targetAmount ? Number(targetAmount) : null;
                    
                    console.log("All targets available:", freeShipTargetNum !== null && mediumGiftTargetNum !== null && targetAmountNum !== null);
                    console.log("Medium gift missing:", mediumGiftTargetNum === null && targetAmountNum !== null);
                    console.log("Target amount missing:", targetAmountNum === null && mediumGiftTargetNum !== null);
                              console.log("targetAmountNum" , targetAmountNum);
                    
                    if (freeShipTargetNum !== null && mediumGiftTargetNum !== null && targetAmountNum !== null) {
                        if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                            let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                            spans[0].style.display = "block";
                            amounts[0].textContent = remaining;
                        } else if (subtotal < mediumGiftTargetNum && spans[1] && amounts[1]) {
                            let remaining = (mediumGiftTargetNum - subtotal).toFixed(2);
                            spans[1].style.display = "block";
                            amounts[1].textContent = remaining;
                        } else if (subtotal < targetAmountNum && spans[2] && amounts[2]) {
                            let remaining = (targetAmountNum - subtotal).toFixed(2);
                            spans[2].style.display = "block";
                            amounts[2].textContent = remaining;
                        } else if (spans[3]) {
                            spans[3].style.display = "block";
                        }
                    } else if (mediumGiftTargetNum === null && targetAmountNum !== null) {
                      if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                        console.log("get it");
                            let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                            spans[0].style.display = "block";
                            amounts[0].textContent = remaining;
                        } else if (subtotal < targetAmountNum && spans[1] && amounts[1]) {
                            let remaining = (targetAmountNum - subtotal).toFixed(2);
                            spans[1].style.display = "block";
                            amounts[1].textContent = remaining;
                        } else if (spans[2]) {
                            spans[2].style.display = "block";
                        }
                    } else if (targetAmountNum === null &&  mediumGiftTargetNum !== null) {
                       if (subtotal < freeShipTargetNum && spans[0] && amounts[0]) {
                            let remaining = (freeShipTargetNum - subtotal).toFixed(2);
                            spans[0].style.display = "block";
                            amounts[0].textContent = remaining;
                        } else if (subtotal < mediumGiftTargetNum && spans[1] && amounts[1]) {
                            let remaining = (mediumGiftTargetNum - subtotal).toFixed(2);
                            spans[1].style.display = "block";
                            amounts[1].textContent = remaining;
                        } else if (spans[2]) {
                            spans[2].style.display = "block";
                        }
                    }
            
            
                    }
                }
            
                function handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget) {
                fetch("/cart.js")
                    .then(response => response.json())
                    .then(cart => {
                        const cartItems = cart.items || [];
                        const mediumGiftItem = cartItems.find(item => item.id === mediumGiftVariantId);
                        const targetGiftItem = cartItems.find(item => item.id === targetGiftVariantId);

                      setTimeout(function() {
                        if (subtotal >= mediumGiftTarget) {
                            if (!mediumGiftItem) {
                                addGiftToCart(mediumGiftVariantId);
                            } else if (mediumGiftItem.quantity !== 1) {
                                updateGiftQuantity(mediumGiftVariantId, 1);
                            }
                        } else if (mediumGiftItem) {
                            removeGiftFromCart(mediumGiftVariantId);
                        }
                        console.log("med inside setimeout");
                      }, 1000);

                      setTimeout(function() {
                        if (subtotal >= premiumTarget) {
                            if (!targetGiftItem) {
                                addGiftToCart(targetGiftVariantId);
                            } else if (targetGiftItem.quantity !== 1) {
                                updateGiftQuantity(targetGiftVariantId, 1);
                            }
                        } else if (targetGiftItem) {
                            removeGiftFromCart(targetGiftVariantId);
                        }
                        console.log("pre inside setimeout");
                       }, 2300); 
                      
                    })
                    .catch(error => console.error("Error fetching cart:", error));
            }
      
                function addGiftToCart(variantId) {
                    fetch("/cart/add.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: variantId, quantity: 1 }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log("Added gift to cart:", data);
                            updateCartDrawer();
                        })
                        .catch(error => console.error("Error adding gift to cart:", error));
                }
            
                function updateGiftQuantity(variantId, quantity) {
                    fetch("/cart/update.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ updates: { [variantId]: quantity } }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log("Updated gift quantity:", data);
                            updateCartDrawer();
                        })
                        .catch(error => console.error("Error updating gift quantity:", error));
                }
            
                function removeGiftFromCart(variantId) {
                    fetch("/cart/update.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ updates: { [variantId]: 0 } }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log("Removed gift from cart:", data);
                            updateCartDrawer();
                        })
                        .catch(error => console.error("Error removing gift from cart:", error));
                }
            
                function updateCartDrawer() {
                    fetch("/cart")
                        .then(response => response.text())
                        .then(html => {
                            let parser = new DOMParser();
                            let doc = parser.parseFromString(html, "text/html");
                            let newCartForm = doc.querySelector("#CartDrawer-Form");
                            let currentCartForm = document.querySelector("#CartDrawer-Form");

                            if (newCartForm && currentCartForm) {
                                console.log("Cart updated in progress bar");
                                currentCartForm.innerHTML = newCartForm.innerHTML;
                            }
                          
                        })
                        .catch(error => console.error("Error updating cart drawer:", error));
                }
            
                fetch("/cart.js")
                    .then(response => response.json())
                    .then(cart => {
                        const subtotal = cart.total_price / 100;
                        const mediumGiftTarget = parseFloat(document.querySelector(".medium-gift")?.textContent) || 0;
                        const premiumTarget = parseFloat(document.querySelector(".target_amount")?.textContent) || 100;
            
                        updateProgressBar(subtotal);
                        updateShippingMessage(subtotal);
                        handleGiftProducts(subtotal, mediumGiftTarget, premiumTarget);
                    })
                    .catch(error => console.error("Error fetching cart:", error));
            }


            // end here

            // remove button clicked

        //     document.addEventListener('click', function (event) {
        // if (!event.target.closest('.cart-remove-button')) return;
        //       // alert("add to cart when removed clicked");
        // var input_checked = document.querySelector('#protectionCheckbox');
        // var cartDrawer = document.querySelector('cart-drawer');
        // var selectedId = 48858005733723;
        // var item_cart = document.querySelector(".cart-items");
        // fetch('/cart.js')
        //     .then(response => response.json())
        //     .then(cart => {
        //         let itemToRemove = cart.items.find(item => item.id === selectedId);
        //       let onlySelectedItem = cart.items.length === 1 && cart.items[0].id === selectedId ? cart.items[0] : null;
        //       setTimeout(function() {
        //       console.log("itemToRemove" , itemToRemove);
        //         if (itemToRemove) {
        //             fetch('/cart/change.js', {
        //                 method: 'POST',
        //                 headers: {
        //                     'Content-Type': 'application/json'
        //                 },
        //                 body: JSON.stringify({
        //                     id: selectedId.toString(),
        //                     quantity: 0,
        //                     sections: "cart-drawer,cart-icon-bubble",
        //                     sections_url: window.location.pathname
        //                 })
        //             })
        //             .then(response => {
        //                 if (!response.ok) {
        //                     return response.json().then(err => { throw new Error(err.message); });
        //                 }
        //                 return response.json();
        //             })
        //               .then(response => {
        //                   setTimeout(function() {
        //                       console.log("Product removed successfully.");
                              
        //                       if (cartDrawer && typeof cartDrawer.renderContents === "function") {
        //                           const cartItems = cart.items || [];
        //                           cartDrawer.renderContents(response);
        //                       }
                      
        //                       // Check if elements exist before accessing .style property
        //                       const drawerHeader = document.querySelector('.drawer__header');
        //                       if (drawerHeader) {
        //                           drawerHeader.style.display = 'none';
        //                       }
                      
        //                       const cartWarnings = document.querySelector('.cart-drawer__warnings');
        //                       if (cartWarnings) {
        //                           cartWarnings.style.display = 'flex';
        //                       }
                      
        //                       const emptyText = document.querySelector('.cart__empty-text');
        //                       if (emptyText) {
        //                           emptyText.style.display = 'block';
        //                       }
                      
        //                       console.log("Cart is now empty.");
        //                   }, 3000);
        //               })
        //               .catch(error => {
        //                   console.error("Error removing product:", error);
        //               });
        //         } else {
        //             console.log("Product not found in cart.");
        //         }
        //         }, 4000);
        //     })
        //     .catch(error => console.error('Error fetching cart:', error));
        // });

          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
